import {createFeatureSelector, createSelector} from '@ngrx/store';
import {VPC} from '../../../services/api/account/vpcs/vpc.model';
import {State} from './organization-account.vpc-list.reducer';

export const loadOrganizationVPCListFeatureKey = 'organizationVPCList';
export const getOrganizationVPCListSelector = createFeatureSelector<State>(loadOrganizationVPCListFeatureKey);

export const getOrganizationVPCList = createSelector(
    getOrganizationVPCListSelector,
    (state: State): VPC[] => state.record
);

export const getOrganizationVPCListLoaded = createSelector(
    getOrganizationVPCListSelector,
    (state: State): boolean => state.loaded
);

export const getOrganizationVPCListLoading = createSelector(
    getOrganizationVPCListSelector,
    (state: State): boolean => state.loading
);

export const getOrganizationVPCListError = createSelector(
    getOrganizationVPCListSelector,
    (state: State): any => state.error
);
